module.exports = __webpack_public_path__ + "media/images/version_merge/speedo_colored-3938aad98c37db8a9fe42186fd3d0382.gif";